import React, { useContext, useState, useEffect } from "react";
import Col from "../../../UIcomponent/Column";
import Image from "../../../UIcomponent/Image";
import LocalContext from "../../../Context/LocalContetxt";
import "./ProfileLessons.scss";
import { ReactComponent as DeleteIcon } from "../../../Assets/icon/delete.svg";
import editIcon from "../../../Assets/icon/drawing.svg";
import ProfileReq from "../../../Utility/Requester/ProfileReq";
import { Notify } from "../../../UIcomponent/NotificationManager";
import { CardTitleAction } from "../../CardTitleAction/CardTitleAction";
import { ThemeContext } from "styled-components";
import { Formik } from "formik";
import { StyledForm, Input } from "../../../UIcomponent/Form";
import { SingleSessionPriceSchema } from "../../../Utility/ValidationSchema";
import StyledButton from "../../../UIcomponent/Button";
import Modal from "../../../UIcomponent/Modal";
import AppConfig from "../../../Utility/Method/AppConfig";
import Metas from "../../Metas";

const ProfileLessons = (props) => {
  const lang = useContext(LocalContext).lang;
  const config = useContext(LocalContext).config;
  const theme = useContext(ThemeContext);
  const [Data, setData] = useState([{ IsTrial: true }, { IsTrial: false }]);
  const [loading, setLoading] = useState(true);
  const [deleteState, setDeleteState] = useState({
    showModal: false,
    id: null,
  });
  const initialEditLessonState = {
    showModal: false,
    IsTrial: null,
    Packages: [],
    loading: false,
    disable: true,
  };
  const [editLessonState, setEditLessonState] = useState({
    ...initialEditLessonState,
  });
  const getPackage = () => {
    ProfileReq.LessonPackage()
      .then((res) => {
        let newData = res.data.map((lsn) => {
          return {
            ...lsn,
            Packages: lsn.Packages.map((pack) => {
              return {
                ...pack,
                valueDisable: true,
              };
            }),
          };
        });
        setData(newData);
        setLoading(false);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (config) {
      getPackage();
    }
  }, [config]);
  const EditHandler = (IsTrial, pack) => {
    setEditLessonState({
      ...editLessonState,
      showModal: true,
      IsTrial,
      Packages: pack,
    });
  };
  const deleteHandler = (id) => {
    setDeleteState({
      showModal: true,
      id,
    });
  };
  const LessonPackage = (lesson) => {
    let SingleSessionPrice = 0;
    let Pack = lesson.packages;
    if (loading === false && Pack !== []) {
      let MonoSession = lesson.packages.filter(
        (each) => each.PackageSessionCount === 1
      )[0];
      if (MonoSession !== undefined) {
        SingleSessionPrice = MonoSession.SingleSessionPrice;
      }
    }
    return (
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        className="o__ProfileLessons__Lesson"
        style={{
          border: loading === true && "none",
        }}
      >
        <Metas
          title="کلاس های من | لینگوتاک"
          description="کلاس های من | لینگوتاک"
        />

        {/* <Col
                    className='o__Lesson__Status'
                >
                    <Col
                        style={{
                            backgroundColor: lesson.IsConfirmed === true ? theme.secondary : theme.lightGray
                        }}
                    >
                    </Col>

                </Col> */}
        <Col
          xl={17}
          lg={17}
          md={17}
          sm={17}
          xs={17}
          className="o__Lesson__Info"
        >
          <Col
            className="o__Lesson__Info__Title"
            loading={loading}
            skeletonType="line"
          >
            {loading === false && lesson.Title}
          </Col>
          {loading === false && <span></span>}
          <Col
            className="o__Lesson__Info__Detail"
            loading={loading}
            skeletonType="line"
          >
            {
              // String.fromCharCode(9679)
              loading === false && (
                <Col>
                  {`${
                    " کلاس " +
                    AppConfig.LessonType(`${lesson.LessonCategory}`)[
                      `${lang}`
                    ] +
                    " - " +
                    AppConfig.Language(`${lesson.TeachingLanguage}`)[
                      `${lang}`
                    ] +
                    " - " +
                    " 1 جلسه " +
                    (SingleSessionPrice
                      ? (SingleSessionPrice / 10).toLocaleString(lang)
                      : 0) +
                    " تومان "
                  }`}
                </Col>
              )
            }
          </Col>
        </Col>

        <Col
          xl={6}
          lg={6}
          md={6}
          sm={6}
          xs={6}
          // xl={8} lg={8} md={8} sm={8} xs={6}
          className="c__Lesson__Actions"
        >
          <Col
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="o__Lesson__Actions"
            loading={loading}
            // skeletonType='line'
          >
            {loading === false && (
              <DeleteIcon
                style={{
                  fill: lesson.hasDeleteAction === false && theme.lightGray,
                  cursor: lesson.hasDeleteAction === false && "no-drop",
                }}
                onClick={
                  lesson.hasDeleteAction === true
                    ? () => deleteHandler(lesson.LessonTypeID)
                    : null
                }
              />
            )}
          </Col>
          {
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="o__Lesson__Actions"
              loading={loading}
              skeletonType="line"
            >
              {loading === false && (
                <Image
                  onClick={() => EditHandler(lesson.IsTrial, lesson.packages)}
                  src={editIcon}
                />
              )}
            </Col>
          }
        </Col>
      </Col>
    );
  };
  const PackActiveHandler = (id, value) => {
    let newPack = [...editLessonState.Packages];
    newPack = newPack.map((each) => {
      return {
        ...each,
        IsActive: id === each.ID ? value : each.IsActive,
      };
    });
    setEditLessonState({
      ...editLessonState,
      disable: false,
      Packages: newPack,
    });
  };
  const PackPriceHandler = (id, value) => {
    let newPack = [...editLessonState.Packages];
    newPack = newPack.map((each) => {
      return {
        ...each,
        SingleSessionPrice:
          id === each.ID ? value * 10 : each.SingleSessionPrice,
      };
    });
    setEditLessonState({
      ...editLessonState,
      disable: false,
      Packages: newPack,
    });
  };
  const PackUpdate = (Package) => {
    setEditLessonState({
      ...editLessonState,
      loading: true,
      disable: true,
    });
    let PromiseArr = Package.map((pack) => {
      let data = {
        SingleSessionPrice: pack.SingleSessionPrice,
        IsActive: pack.IsActive,
      };
      return ProfileReq.PackageUpdate(pack.ID, data);
    });
    Promise.all(PromiseArr)
      .then((res) => {
        setEditLessonState(initialEditLessonState);
        getPackage();
        Notify("success", "تغییرات با موفقیت انجام شد", 4000);
      })
      .catch((err) => {
        Notify("err", "خطا در ذخیره تغییرات ،مجدد تلاش کنید", 4000);
        setEditLessonState({
          ...editLessonState,
          Packages: [],
          loading: false,
        });
      });
  };
  return (
    <>
      <Col
        className="l__ProfileLessons"
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        lang={lang}
      >
        <Col
          className="c__ProfileLessons"
          xl={23}
          lg={23}
          md={23}
          sm={23}
          xs={23}
        >
          <Col
            xl={22}
            lg={22}
            md={22}
            sm={22}
            xs={22}
            className="c__ProfileLessons__Title"
          >
            <CardTitleAction
              title="مدیریت دروس"
              editActionTitle="ایجاد درس"
              editAction={() => {
                setEditLessonState({
                  ...editLessonState,
                  showModal: true,
                });
              }}
              hasEditAction={false}
              hasWatchAction={false}
              role={config.role}
            />
          </Col>
          <Col
            className="o__ProfileLessons"
            xl={22}
            lg={22}
            md={22}
            sm={22}
            xs={22}
          >
            <Col
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="o__ProfileLessons__Title"
            >
              {loading === false && "اصلی"}
            </Col>
            {Data.filter((each, i) => each.IsTrial === false).map((lesson) => {
              return (
                <LessonPackage
                  key={lesson.ID}
                  Title={lesson.Title}
                  Description={lesson.Description}
                  IsConfirmed={lesson.IsConfirmed}
                  packages={lesson.Packages}
                  TeachingLanguage={lesson.TeachingLanguage}
                  LessonCategory={lesson.LessonCategory}
                  hasDeleteAction={lesson.LessonCategory === 1 ? false : true}
                  id={lesson.ID}
                  hasEditAction={true}
                />
              );
            })}

            <Col
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="o__ProfileLessons__Title"
            >
              {loading === false && "آزمایشی"}
            </Col>
            {Data.filter((each, i) => each.IsTrial === true).map((lesson) => {
              return (
                <LessonPackage
                  key={lesson.ID}
                  IsConfirmed={lesson.IsConfirmed}
                  Title={lesson.Title}
                  Description={lesson.Description}
                  packages={lesson.Packages}
                  TeachingLanguage={lesson.TeachingLanguage}
                  LessonCategory={lesson.LessonCategory}
                  id={lesson.ID}
                  hasDeleteAction={lesson.LessonCategory === 1 ? false : true}
                  hasEditAction={true}
                />
              );
            })}
          </Col>
        </Col>
      </Col>
      <Modal
        visible={deleteState.showModal}
        onCancel={() => {
          setDeleteState({
            showModal: false,
            id: null,
          });
        }}
      >
        <Col className="c__LessonPackageDelete">
          <Col
            xl={23}
            lg={23}
            md={23}
            sm={23}
            xs={23}
            className="o__LessonPackageDelete__Header"
          >
            حذف درس
          </Col>
          <Col
            xl={23}
            lg={23}
            md={23}
            sm={23}
            xs={23}
            className="o__LessonPackageDelete__Content"
          >
            آیا از حذف این مورد اطمینان دارید ؟
          </Col>
          <Col
            xl={23}
            lg={23}
            md={23}
            sm={23}
            xs={23}
            className="o__LessonPackageDelete__Footer"
          >
            <StyledButton className="o__LessonPackageDelete__Footer__ConfirmBtn">
              تایید
            </StyledButton>
            <StyledButton className="o__LessonPackageDelete__Footer__CancelBtn">
              لغو
            </StyledButton>
          </Col>
        </Col>
      </Modal>
      <Modal
        visible={editLessonState.showModal}
        onCancel={() => {
          setEditLessonState(initialEditLessonState);
        }}
        headerTitle="ویرایش درس"
        type="submit"
        confirmText={"ذخیره"}
        hasWrapper
        onConfirm={() => {
          PackUpdate(editLessonState.Packages);
        }}
        disable={editLessonState.disable}
        loading={editLessonState.loading}
      >
        <Col
          className="c__LessonPackageEdit"
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
        >
          <Col
            className="o__LessonPackageEdit__Header"
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
          >
            <Col
              // xl={3} lg={3} md={3} sm={3} xs={3}
              className="o__Package__ActiveStatus"
            ></Col>
            <Col
              xl={7}
              lg={7}
              md={7}
              sm={5}
              xs={5}
              className="c__LessonPackageEdit__Header__Title"
            >
              تعداد جلسه
            </Col>
            <Col
              xl={9}
              lg={9}
              md={9}
              sm={7}
              xs={7}
              className="c__LessonPackageEdit__Header__Title"
            >
              قیمت (تومان)
            </Col>
            <Col
              xl={7}
              lg={7}
              md={7}
              sm={7}
              xs={7}
              className="c__LessonPackageEdit__Header__Title"
            >
              قیمت مجموع
            </Col>
          </Col>
          {editLessonState.Packages.map((pack) => {
            return (
              <Formik
                validationSchema={SingleSessionPriceSchema}
                initialValues={{
                  price:
                    pack.SingleSessionPrice !== null
                      ? pack.SingleSessionPrice / 10
                      : 0,
                }}
              >
                {(formik) => (
                  <StyledForm>
                    <Col
                      className="o__Package"
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{
                        opacity: pack.IsActive === false && "0.3",
                      }}
                    >
                      <Col
                        // xl={3} lg={3} md={3} sm={3} xs={3}
                        className="o__Package__ActiveStatus"
                      >
                        <Col
                          className="o__Package__ActiveStatus__Checkbox"
                          onClick={
                            pack.PackageSessionCount === 1
                              ? null
                              : () => PackActiveHandler(pack.ID, !pack.IsActive)
                          }
                        >
                          {pack.IsActive && (
                            <Col className="o__Package__ActiveStatus__Checkbox--Active"></Col>
                          )}
                        </Col>
                      </Col>
                      <Col
                        xl={7}
                        lg={7}
                        md={7}
                        sm={23}
                        xs={23}
                        className="o__Package__SessionCount"
                      >
                        {pack.PackageSessionCount +
                          " جلسه " +
                          "- " +
                          pack.SessionLengthInMinute +
                          "دقیقه "}
                      </Col>
                      <Col
                        xl={9}
                        lg={9}
                        md={9}
                        sm={12}
                        xs={12}
                        className="o__Package__SingleSessionPrice"
                      >
                        <Input
                          lable="price"
                          name="price"
                          type="tel"
                          value={formik.values.price}
                          validateonchange={true}
                          onChange={(e) => {
                            let value = e.target.value;
                            if (Number(value) <= 500000) {
                              formik.setFieldValue(
                                "price",
                                Number(e.target.value)
                              );
                              setTimeout(() => {
                                PackPriceHandler(pack.ID, value);
                              }, 0);
                              if (!formik.errors.price) {
                                setEditLessonState({
                                  ...editLessonState,
                                  disable: false,
                                });
                              }
                            }
                          }}
                          outLine
                          disabled={pack.IsActive === false ? true : false}
                        ></Input>
                        {formik.errors.price}
                      </Col>
                      <Col
                        xl={7}
                        lg={7}
                        md={7}
                        sm={12}
                        xs={12}
                        className="o__Package__TotalPrice"
                      >
                        {(
                          ((pack.SingleSessionPrice || 0) *
                            pack.PackageSessionCount) /
                          10
                        ).toLocaleString(lang) + " تومان "}
                      </Col>
                    </Col>
                  </StyledForm>
                )}
              </Formik>
            );
          })}
        </Col>
      </Modal>
    </>
  );
};

export default ProfileLessons;
